import { Button, InputAdornment, List, ListItem, ListItemButton, TextField, useTheme } from "@mui/material";
import { Add, Search } from "@mui/icons-material";
import AddVpn from "./AddVpn";
import { useEffect, useState } from "react";
import "./Vpn.css";
import axiosInstance from "../../../axios/axios";
import useRolePermissions from "../../../shared/hooks/useRolePermissions";
import { ROLES_CONTENT_PROPS } from "../../../shared/constants/constant-data";

interface VpnTunnel {
  name: string;
  status: string;
  description: string;
  paused: boolean;
  tunnel_status: string;
  tunnel_name: string;
  tunnel_description: string;
}

const VpnList = ({ vpnData, onVpnSelect, onFetchVpnCall }: any) => {
  const [openAddVpn, setOpenAddVpn] = useState(false);
  const [selectedVpn, setSelectedVpn] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
   const { hasPermissions } = useRolePermissions();

  useEffect(() => {
    if (vpnData.length > 0) {
      setSelectedVpn(vpnData[0].tunnel_name);
      onVpnSelect(vpnData[0]);
    }
  }, [vpnData]);
  const getScanStatusClass = (value: any): string => {
    const arr = ['low', 'critical','partial', 'cancle', 'in-pgr'];
    return arr[value];
  };

  const addVpnCall = () => {
    onFetchVpnCall();
  }

  const handleVpnClick = (tunnel: VpnTunnel) => {
    setSelectedVpn(tunnel.tunnel_name);
    onVpnSelect(tunnel);
  };

  const filteredVpnData = vpnData.filter((tunnel:any) =>
    tunnel.tunnel_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <div className={`vpn-search-header ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
        <TextField
          fullWidth
          placeholder="Search VPN"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": { border: "none" },
              backgroundColor: isDarkMode ? "#191C24" : "#ffffff",
              color: isDarkMode ? "#ffffff" : "#000000",
            },
            "& .MuiInputBase-root:not(.MuiInputBase-multiline)": {
              height: "50px",
            },
            "& .MuiInputBase-input::placeholder": {
              color: isDarkMode ? "#a0a0a0" : "#666666",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ fill: isDarkMode ? "#a0a0a0" : "#666666", margin: "0" }} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {hasPermissions(ROLES_CONTENT_PROPS.CREATE_VPN) &&  <Button
                  className={`btn add-vpn ${isDarkMode ? 'dark-mode' : 'light-mode'}`}
                  sx={{
                    "&:focus": { outline: "none" },
                    position: "relative",
                    bottom: "0px",
                    left: "20px",
                    color: isDarkMode ? "#a0a0a0" : "#666666",
                  }}
                  onClick={() => setOpenAddVpn(true)}
                >
                  <Add sx={{ fill: isDarkMode ? "#a0a0a0" : "#666666", "&:hover": { fill: "#3a2ada" } }} />
                </Button>}
               
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className={`vpn-search-list scroll ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
        <List style={{ padding: "0" }}>
          {filteredVpnData.map((tunnel:any, index:any) => (
            <ListItem
              key={index}
              style={{ padding: "0" }}
              className={`${selectedVpn === tunnel.tunnel_name ? 'selected-vpn' : ''} ${isDarkMode ? 'dark-mode' : 'light-mode'}`}
              onClick={() => handleVpnClick(tunnel)}
            >
              <ListItemButton sx={{padding: "0",}}>
                <div className={`vpn-list-item ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                  <div className={`vpn-tunnelname ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                    <span>{tunnel.tunnel_name}</span>
                    {tunnel.paused ? (
                      <span className={`vulnerab_label partial ${selectedVpn === tunnel.tunnel_name ? 'selected-status white-text' : ''} ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>Paused</span>
                    ) : (
                      <span className={`vulnerab_label ${getScanStatusClass(tunnel.status)} ${selectedVpn === tunnel.tunnel_name ? 'selected-status white-text' : ''} ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                        {tunnel.tunnel_status}
                      </span>
                    )}
                  </div>
                  <p className={`vpn-description ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>{tunnel.tunnel_description}</p>
                </div>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </div>
      {openAddVpn && <AddVpn open={openAddVpn} onClose={() => setOpenAddVpn(false)} OnAddVpnCall={addVpnCall} />}
    </>
  );
};

export default VpnList;